document.addEventListener("cart:item-added", function (evt) {
  return
  validate()
});

document.addEventListener("line-item:change:end", function (evt) {
  return
  validate()
});

function validate() {
  fetch(window.Shopify.routes.root + "cart.js").then(function (response) {
      return response.json();
  }).then(function (data) {
      check_items(data);
  }).catch(function (err) {
      console.warn('Something went wrong with CA Validator.', err);
  });
}

function check_items(cart) {
  var hasCaliforniaItem = false
  var hasNonCaliforniaItem = false
  cart.items.forEach(item => {
    console.log(item.properties)
    if (item.properties._CAIA.toLowerCase() === 'true') {
       hasCaliforniaItem = true
    }
    else if (item.properties._CAIARestricted.toLowerCase() === 'true') {
       hasNonCaliforniaItem = true
    }
  })
  if (hasCaliforniaItem && !hasNonCaliforniaItem) {
    document.getElementById("InvalidCartWarning").style.display = 'none'
    document.getElementById("cart-drawer-panel").style.gridTemplateRows =  'auto 1fr auto'
  }
  else if (hasCaliforniaItem && hasNonCaliforniaItem) {
    document.getElementById("InvalidCartWarning").style.display = 'flex'
    document.getElementById("cart-drawer-panel").style.gridTemplateRows =  'auto auto 1fr auto'
  }
  else {
    document.getElementById("InvalidCartWarning").style.display = 'none'
    document.getElementById("cart-drawer-panel").style.gridTemplateRows =  'auto 1fr auto'
  }
}

Window.onload = validate();